import type {
  DrawingToolInstance,
  ThreePointCoordinates,
  TimestampToX,
  PriceToY,
} from "./types";
import { applyLineStyle, drawHandleCircle } from "./drawHelpers";

export function drawParallelChannel(
  ctx: CanvasRenderingContext2D,
  coords: ThreePointCoordinates,
  instance: DrawingToolInstance,
  timestampToX: TimestampToX,
  priceToY: PriceToY,
  draggingCoords?: ThreePointCoordinates,
) {
  const { point1, point2, point3 } = draggingCoords ?? coords;
  const x1 = timestampToX(point1.timestamp);
  const y1 = priceToY(point1.price);
  const x2 = timestampToX(point2.timestamp);
  const y2 = priceToY(point2.price);
  const x3 = (x1 + x2) / 2;
  const y3 = priceToY(point3.price);
  const dy = y3 - (y1 + y2) / 2;
  const by1 = y1 + dy;
  const by2 = y2 + dy;

  applyLineStyle(ctx, instance.mainLine.color, instance.mainLine.width, instance.mainLine.opacity);
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.moveTo(x1, by1);
  ctx.lineTo(x2, by2);
  ctx.stroke();

  ctx.fillStyle = instance.background.color;
  ctx.globalAlpha = instance.background.opacity / 100;
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.lineTo(x2, by2);
  ctx.lineTo(x1, by1);
  ctx.closePath();
  ctx.fill();

  drawHandleCircle(ctx, x1, y1, instance.mainLine.color);
  drawHandleCircle(ctx, x2, y2, instance.mainLine.color);
  drawHandleCircle(ctx, x3, y3, instance.mainLine.color);
}
